import { useQuery } from "@tanstack/react-query";
import { getThread } from "../lib/api-client";
import { mailboxQueryKeys } from "../lib/query-keys";

export function useThread(mailboxId: string | undefined, threadId: string | undefined) {
  return useQuery({
    queryKey: mailboxQueryKeys.thread(mailboxId ?? "", threadId ?? ""),
    queryFn: () => getThread(mailboxId!, threadId!),
    enabled: Boolean(mailboxId && threadId),
    staleTime: 10_000,
  });
}
